import { Content } from '@prismicio/client';
import { JSXMapSerializer, SliceComponentProps } from '@prismicio/react';

import { JSX } from 'react';
import styles from './Modal.module.scss';
import {
  AdvertiserDisclosureModal,
  CAPrivacyNotice,
  CreditAuthorization,
  ElectronicConsent,
  PartnerList,
  PrivacyPolicyModal,
  TermsOfServiceModal,
} from './parts';
import Lenders from './parts/Lenders/Lenders';

const components: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.text}>{children}</p>,
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
  heading3: ({ children }) => <h3 className={styles.title}>{children}</h3>,
  heading4: ({ children }) => <h4 className={styles.title}>{children}</h4>,
  heading5: ({ children }) => <h5 className={styles.title}>{children}</h5>,
};

export type ModalProps = SliceComponentProps<Content.ModalSlice>;

const Modal = ({ slice }: ModalProps): JSX.Element => {
  const renderContent = () => {
    switch (slice.variation) {
      case 'electronicConsent':
        return (
          <ElectronicConsent
            components={components}
            styles={styles}
            data={slice.primary}
          />
        );
      case 'creditAuthorization':
        return (
          <CreditAuthorization
            data={slice.primary}
            styles={styles}
            components={components}
          />
        );
      case 'partnerList':
        return (
          <PartnerList
            data={slice.primary}
            styles={styles}
            components={components}
          />
        );
      case 'caPrivacyNotice':
        return <CAPrivacyNotice data={slice.primary} />;
      case 'termsOfService':
        return <TermsOfServiceModal data={slice.primary} />;
      case 'lenders':
        return <Lenders data={slice.primary} />;
      case 'advertiserDisclosure':
        return <AdvertiserDisclosureModal data={slice.primary} />;
      case 'privacyPolicy':
        return <PrivacyPolicyModal data={slice.primary} />;
      default:
        return null;
    }
  };

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
      className={`${styles.wrapper} ${styles[slice.variation]}`}
    >
      {renderContent()}
    </section>
  );
};

export default Modal;
